import { render, staticRenderFns } from "./PayrollHistoryReceipt.vue?vue&type=template&id=7d41dcf9&scoped=true"
import script from "./PayrollHistoryReceipt.vue?vue&type=script&lang=ts"
export * from "./PayrollHistoryReceipt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d41dcf9",
  null
  
)

export default component.exports